import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TopNavigator from "components/layout/TopNavigator/TopNavigator";

// CSS imports
import 'styles/Font.css';

// Hook imports
// import usePreventZoom from "hooks/usePreventZoom";
import usePreventInputScroll from "hooks/usePreventInputScroll";
import usePreventHorizontalScroll from "hooks/usePreventHorizontalScroll";

// ----------------------------------------------------------------------
// styles 객체를 가장 먼저 정의합니다. (ReferenceError 방지)
// ----------------------------------------------------------------------
const styles = {
    backgroundWrapper: {
        background: '#0D042D',
        width: '100%',
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        margin: '0 auto',
        boxSizing: 'border-box',
    },
    fixedHeaderWrapper: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        zIndex: 100,
        backgroundColor: '#0D042D',
    },
    statusBar: {
        flexShrink: 0,
        backgroundColor: 'transparent',
    },
    mainContent: {
        flex: 1,
        padding: '80px 24px 40px',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    },
    tabContainer: {
        width: '100%',
        display: 'flex',
        borderBottom: '1px solid #3A394A',
        marginBottom: '24px',
    },
    tabButton: {
        flex: 1,
        background: 'transparent',
        border: 'none',
        padding: '12px 0',
        fontFamily: 'Pretendard',
        fontSize: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all 0.2s',
    },
    pageTitle: {
        fontFamily: 'Pretendard',
        fontSize: '20px',
        fontWeight: 700,
        color: '#FFFFFF',
        marginBottom: '16px',
    },
    contentWrapper: {
        width: '100%',
        color: '#D4D4D4',
        fontFamily: 'Pretendard',
        fontSize: '14px',
        lineHeight: 1.6,
        wordBreak: 'keep-all',
        whiteSpace: 'pre-line',
        textAlign: 'left',
    },
    // 내부 콘텐츠 스타일 (이전에 인라인으로 쓰이던 것들을 위해 추가)
    section: {
        marginBottom: '40px',
    },
    listItem: {
        margin: '5px 0 5px 16px',
        paddingLeft: '5px',
        textIndent: '-5px',
        color: '#9A9A9A',
    },
};

// ----------------------------------------------------------------------
// 이용약관 내용 (TermsModal.jsx 내용 그대로 가져옴)
// ----------------------------------------------------------------------
const policyContent = (
    <div style={styles.section}>
        <h3>제1장 총칙</h3>
        <h4>제1조 목적</h4>
        <p>이 약관은 HypeHaus에서 제공하는 서비스 이용조건 및 절차에 관한 사항과 기타 필요한 사항을 HypeHaus과(와) 이용자의 권리, 의미 및 책임사항 등을 규정함을 목적으로 합니다.</p>

        <h4>제2조 약관의 효력과 변경</h4>
        <p>(1) 이 약관은 이용자에게 공시함으로서 효력이 발생합니다.</p>
        <p>(2) HypeHaus는 사정 변경의 경우와 영업상 중요사유가 있을 때 약관을 변경할 수 있으며, 변경된 약관은 전항과 같은 방법으로 효력이 발생합니다.</p>

        <h4>제3조 약관 외 준칙</h4>
        <p>이 약관에 명시되지 않은 사항이 관계법령에 규정되어 있을 경우에는 그 규정에 따릅니다.</p>

        <h3>제2장 회원 가입과 서비스 이용</h3>
        <h4>제1조 회원의 정의</h4>
        <p>회원이란 HypeHaus에서 회원으로 적합하다고 인정하는 일반 개인으로 본 약관에 동의하고 서비스의 회원가입 양식을 작성하고 'ID'와 '비밀번호'를 발급받은 사람을 말합니다.</p>

        <h4>제2조 서비스 가입의 성립</h4>
        <p>(1) 서비스 가입은 이용자의 이용신청에 대한 HypeHaus의 이용승낙과 이용자의 약관내용에 대한 동의로 성립됩니다.</p>
        <p>(2) 회원으로 가입하여 서비스를 이용하고자 하는 희망자는 HypeHaus에서 요청하는 개인 신상정보를 제공해야 합니다.</p>
        <p>(3) 이용자의 가입신청에 대하여 HypeHaus에서 승낙한 경우, HypeHaus는 회원 ID와 기타 HypeHaus에서 필요하다고 인정하는 내용을 이용자에게 통지합니다.</p>
        <p>(4) 가입할 때 입력한 ID는 변경할 수 없으며, 한 사람에게 오직 한 개의 ID가 발급됩니다.</p>
        <p>(5) HypeHaus는 다음 각 호에 해당하는 가입신청에 대하여는 승낙하지 않습니다.</p>
        <p style={styles.listItem}>가. 다른 사람의 명의를 사용하여 신청하였을 때</p>
        <p style={styles.listItem}>나. 본인의 실명으로 신청하지 않았을 때</p>
        <p style={styles.listItem}>다. 가입 신청서의 내용을 허위로 기재하였을 때</p>
        <p style={styles.listItem}>라. 사회의 안녕과 질서 혹은 미풍양속을 저해할 목적으로 신청하였을 때</p>

        <h4>제3조 서비스 이용 및 제한</h4>
        <p>(1) 서비스 이용은 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간을 원칙으로 합니다.</p>
        <p>(2) 전항의 서비스 이용시간은 시스템 정기점검 등 HypeHaus에서 필요한 경우, 회원에게 사전 통지한 후 제한할 수 있습니다.</p>
        <p>(3) 서비스 내용 중 온라인상담은 답변하는 전문의사의 개인사정에 따라 1일 24시간 서비스가 불가능 할 수도 있습니다.</p>

        <h4>제4조 서비스의 사용료</h4>
        <p>(1) 서비스는 회원으로 등록한 모든 사람들이 무료로 사용할 수 있습니다.</p>
        <p>(2) HypeHaus에서 서비스를 유료화할 경우 유료화의 시기, 정책, 비용에 대하여 유료화 실시 이전에 서비스에 공시하여야 합니다.</p>

        <h3>제3장 서비스 탈퇴, 재가입 및 이용 제한</h3>
        <h4>제1조 서비스 탈퇴</h4>
        <p>(1) 회원이 서비스의 탈퇴를 원하면 회원 본인이 직접 전자메일을 통해 운영자에게 해지 신청을 요청해야 합니다.</p>
        <p>(2) 탈퇴 신청시 본인임을 알 수 있는 이름, ID, 전화번호, 해지사유를 알려주면, 가입기록과 일치 여부를 확인한 후 가입을 해지합니다.</p>
        <p>(3) 탈퇴 여부는 기존의 ID와 비밀번호로 로그인이 되지 않으면 해지된 것입니다.</p>

        <h4>제2조 서비스 재가입</h4>
        <p>(1) 제1조에 의하여 서비스에서 탈퇴한 사용자가 재가입을 원할 경우, 회원 본인이 직접 전자메일을 통해 운영자에게 재가입을 요청하면 됩니다.</p>
        <p>(2) 재가입 요청시 본인임을 알 수 있는 이름, ID, 전화번호를 알려주면 재가입 처리가 이루어집니다.</p>
        <p>(3) 기존의 ID와 비밀번호로 로그인이 되면 재가입이 이루어진 것입니다.</p>

        <h4>제3조 서비스 이용제한</h4>
        <p>HypeHaus는 회원이 다음 사항에 해당하는 행위를 하였을 경우, 사전통지 없이 이용계약을 해지하거나 기간을 정하여 서비스 이용을 중지할 수 있습니다.</p>
        <p style={styles.listItem}>가. 공공 질서 및 미풍 양속에 반하는 경우</p>
        <p style={styles.listItem}>나. 범죄적 행위에 관련되는 경우</p>
        <p style={styles.listItem}>다. 국익 또는 사회적 공익을 저해할 목적으로 서비스 이용을 계획 또는 실행할 경우</p>
        <p style={styles.listItem}>라. 타인의 ID 및 비밀번호를 도용한 경우</p>
        <p style={styles.listItem}>마. 타인의 명예를 손상시키거나 불이익을 주는 경우</p>
        <p style={styles.listItem}>바. 같은 사용자가 다른 ID로 이중 등록을 한 경우</p>
        <p style={styles.listItem}>사. 서비스에 위해를 가하는 등 건전한 이용을 저해하는 경우</p>
        <p style={styles.listItem}>아. 기타 관련 법령이나 HypeHaus에서 정한 이용조건에 위배되는 경우</p>

        <h3>제4장 서비스에 관한 책임의 제한</h3>
        <h4>제1조 온라인상담</h4>
        <p>(1) HypeHaus는 서비스의 회원 혹은 사용자들의 상담내용이 상담의사와 서비스 관리자를 제외한 제3자에게 유출되지 않도록 최선을 다해 보안을 유지하려고 노력합니다. 그러나 다음과 같은
            경우에는 상담 내용 공개 및 상실에 대하여 HypeHaus의 책임이 없습니다.</p>
        <p style={styles.listItem}>가. 사용자의 부주의로 암호가 유출되어 상담내용이 공개되는 경우</p>
        <p style={styles.listItem}>나. 사용자가 '삭제' 기능을 사용하여 상담을 삭제하였을 경우</p>
        <p style={styles.listItem}>다. 천재지변이나 그 밖의 HypeHaus에서 통제할 수 없는 상황에 의하여 상담내용이 공개되거나 상담내용이 상실되었을 경우</p>
        <p>(2) 회원이 신청한 상담에 대한 종합적이고 적절한 답변을 위하여 주치의사, 각과 전문의사들은 상담내용과 답변을 참고할 수 있습니다.</p>
        <p>(3) 서비스에서 진행된 상담의 내용은 개인 신상정보를 삭제한 다음 아래와 같은 목적으로 사용할 수 있습니다.</p>
        <p style={styles.listItem}>가. 학술활동</p>
        <p style={styles.listItem}>나. 인쇄물, CD-ROM 등의 저작활동</p>
        <p style={styles.listItem}>다. FAQ, 추천상담 등의 서비스 내용의 일부</p>
        <p>(4) 상담에 대한 답변내용은 각 전문의사의 의학적 지식을 바탕으로 한 주관적인 답변으로 HypeHaus의 서비스 의견을 대표하지는 않습니다.</p>
        <p>(5) 아래와 같은 상담을 신청하는 경우에는 온라인상담 전체 또는 일부 제공하지 않을 수 있습니다.</p>
        <p style={styles.listItem}>가. 같은 내용의 상담을 반복하여 신청하는 경우</p>
        <p style={styles.listItem}>나. 상식에 어긋나는 표현을 사용하여 상담을 신청하는 경우</p>
        <p style={styles.listItem}>다. 진단명을 요구하는 상담을 신청하는 경우</p>
        <p style={styles.listItem}>라. 치료비, 검사비, 의약품 가격 등에 대하여 상담을 신청하는 경우</p>

        <h4>제2조 정보 서비스</h4>
        <p>(1) 서비스에서 제공되는 내용은 개략적이며 일반적인 내용이고 정보제공만을 위해 제공됩니다. 서비스에서 제공되는 정보나 상담은 절대로 의학적인 진단을 대신할 수 없습니다. 서비스에서 제공되는
            정보나 상담은 결코 의학적 진단, 진료 혹은 치료를 대신하려는 목적이 아닙니다. 회원의 건강상태에 관한 의문점이나 걱정이 있다면 실제 전문의사를 찾아 진단을 받아야 합니다. 어떠한 경우에도
            서비스에서 제공하는 정보때문에 의사의 진단을 무시하거나, 진단, 진료 혹은 치료받는 것을 미루지 마십시오.</p>
        <p>(2) HypeHaus는 서비스에서 언급된 어떠한 특정한 검사나 제품 혹은 치료법도 추천하지 않습니다. 서비스에 표현된 의견은 모두 해당 상담의사의 의견입니다. HypeHaus는 서비스에서 제공된
            어떠한 문서나 상담의 내용에 대해서도 책임을 지지 않습니다.</p>
        <p>(3) 본 서비스의 정보, 서비스에 참여하는 전문의사 혹은 서비스를 사용하는 다른 회원이나 방문객의 의견을 받아들이는 것은 전적으로 사용자의 판단에 따르는 것입니다. 따라서 HypeHaus에서는
            회원에게 제공된 어떠한 제품의 활용, 정보, 아이디어 혹은 지시로부터 비롯하는 어떠한 손해, 상해 혹은 그 밖의 불이익에 대한 책임을 지지 않습니다.</p>

        <h3>제5장 의무</h3>
        <h4>제1조 회사의 의무</h4>
        <p>(1) HypeHaus는 특별한 사정이 없는 한 회원이 서비스를 이용할 수 있도록 합니다.</p>
        <p>(2) HypeHaus는 이 약관에서 정한 바에 따라 계속적, 안정적으로 서비스를 제공할 의무가 있습니다.</p>
        <p>(3) HypeHaus는 회원으로부터 소정의 절차에 의해 제기되는 의견에 대해서 적절한 절차를 거쳐 처리하며, 처리시 일정기간이 소요될 경우 회원에게 그 사유와 처리 일정을 알려주어야
            합니다.</p>

        <h4>제2조 회원정보 보안의 의무</h4>
        <p>(1) 회원의 ID와 비밀번호에 관한 모든 관리의 책임은 회원에게 있습니다.</p>
        <p>(2) 회원은 서비스의 일부로 보내지는 서비스의 전자우편을 받는 것에 동의합니다.</p>
        <p>(3) 자신의 ID가 부정하게 사용된 경우, 회원은 반드시 HypeHaus에 그 사실을 통보해야 합니다.</p>
        <p>(4) HypeHaus는 개인의 신분 확인이 가능한 정보를 회원 혹은 사용자의 사전허락 없이 HypeHaus과(와) 관계가 없는 제3자에게 팔거나 제공하지 않습니다. 그러나 HypeHaus는
            자발적으로 제공된 등록된 정보를 다음과 같은 경우에 활용할 수 있습니다.</p>
        <p style={styles.listItem}>가. 회원들에게 유용한 새 기능, 정보, 서비스 개발에 필요한 정보를 개발자들에게 제공하는 경우</p>
        <p style={styles.listItem}>나. 광고주들에게 서비스 회원과 사용자 집단에 대한 통계적(결코 회원 개개인의 신분이 드러나지 않는) 정보를 제공하는 경우</p>
        <p style={styles.listItem}>다. 회원과 사용자 선호에 따른 광고 또는 서비스를 실시하기 위하여 회사에서 사용하는 경우</p>
        <p>(5) 게시판 등의 커뮤니케이션 공간에 개인신분 확인이 가능한 정보가 자발적으로 공개될 수 있습니다. 이런 경우 공개된 정보가 제3자에 의해 수집되고 연관되어지며 사용될 수 있으며 제3자로부터
            원하지 않는 메시지를 받을 수도 있습니다. 제3자의 그러한 행위는 HypeHaus에서 통제할 수 없습니다. 따라서 HypeHaus는 HypeHaus에서 통제할 수 없는 방법에 의한 회원정보의
            발견 가능성에 대해 아무런 보장을 하지 않습니다.</p>
        <p>(6) HypeHaus는 서비스의 사용의 편의를 위하여 Cookie 기술을 사용할 수 있습니다. Cookie란 다시 방문하는 사용자를 파악하고 그 사용자의 계속된 접속과 개인화된 서비스 제공을
            돕기 위해 웹사이트가 사용하는 작은 텍스트 파일입니다. 일반적으로 Cookie는 Cookie를 부여한 사이트 밖에서는 의미가 없는 유일한 번호를 사용자에게 부여하는 방식으로 작동합니다.
            Cookie는 사용자의 시스템 내부로 침입하지 않으며 사용자의 파일에 위험하지 않습니다. HypeHaus는 서비스의 광고주나 관련있는 제3자가 Cookie를 사용하는 것을 막을 수 없습니다.
            회원 혹은 사용자가 Cookie를 사용한 정보수집을 원하지 않는 경우에는 웹 브라우저에서 Cookie를 받아들일지 여부를 조절할 수 있습니다. 하지만 서비스가 제대로 작동하기 위해서는
            Cookie의 사용이 필요할 수 있습니다.</p>
        <p>(7) HypeHaus는 회원의 정보를 서비스 또는 회사와 업무제휴 업체간에 상호 제공/활용할 수 있습니다.</p>

        <h3>제6장 분쟁조정</h3>
        <p>(1) 본 이용약관에 규정된 것을 제외하고 발생하는 서비스 이용에 관한 제반문제에 관한 분쟁은 최대한 쌍방합의에 의해 해결하도록 한다.</p>
        <p>(2) 서비스 이용으로 발생한 분쟁에 대해 소송이 제기될 경우 회사의 소재지를 관할하는 법원을 관할법원으로 합니다.</p>

        <h4>부칙</h4>
        <p>이 약관은 2022년 2월 8일 시행합니다.</p>
    </div>
);

// ----------------------------------------------------------------------
// 개인정보처리방침 내용 (TermsModal.jsx 내용 그대로 가져옴)
// ----------------------------------------------------------------------
const privacyContent = (
    <div style={styles.section}>
        <h3>개인정보수집동의</h3>
        <p>HypeHaus는 귀하의 개인정보보호를 매우 중요시하며, 개인정보보호방침을 통하여 귀하께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고
            있는지 알려드립니다.</p>

        <h3>개인정보 수집에 대한 동의</h3>
        <p>HypeHaus는 귀하께 회원가입시 개인정보보호방침 또는 이용약관의 내용을 공지하며 회원가입버튼을 클릭하면 개인정보 수집에 대해 동의하신 것으로 봅니다.</p>

        <h3>개인정보의 수집목적 및 이용목적</h3>
        <p>HypeHaus는 다음과 같은 목적을 위하여 개인정보를 수집하고 있습니다.</p>
        <p style={styles.listItem}>- HypeHaus 및 제휴사이트 서비스를 위한 회원 가입 및 이용아이디 발급</p>
        <p style={styles.listItem}>- 서비스의 이행(경품 등 우편물 배송 및 예약에 관한 사항)</p>
        <p style={styles.listItem}>- 장애처리 및 개별 회원에 대한 개인 맞춤서비스</p>
        <p style={styles.listItem}>- 서비스 이용에 대한 통계수집</p>
        <p style={styles.listItem}>- 기타, 새로운 서비스 및 정보 안내</p>
        <p>단, 이용자의 기본적 인권침해의 우려가 있는 민감한 개인정보는 수집하지 않습니다. HypeHaus는 상기 범위 내에서 보다 풍부한 서비스를 제공하기 위해 이용자의 자의에 의한 추가정보를
            수집합니다.</p>

        <h3>수집하는 개인정보 항목</h3>
        <p>HypeHaus는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.</p>
        <p style={styles.listItem}>- 수집항목: 이름, 생년월일, 성별, 로그인 ID, 비밀번호, 자택 전화번호, 자택 주소, 휴대전화번호, 이메일, 서비스이용기록, 접속로그, 쿠키,
            접속 IP 정보 , 결제기록</p>
        <p style={styles.listItem}>- 개인정보 수집방법: 홈페이지(회원가입, 게시판, 온라인상담, 온라인예약 등)쿠키에 의한 개인정보 수집</p>
        <p>HypeHaus는 귀하에 대한 정보를 저장하고 수시로 찾아내는 '쿠키 (cookie)' 를 사용합니다. 쿠키는 웹사이트가 귀하의 컴퓨터 브라우저(넷스케이프, 인터넷 익스플로러 등)로 전송하는
            소량의 정보입니다. 귀하가 웹사이트에 접속을 하면 HypeHaus 웹서버는 귀하의 브라우저에 있는 쿠키의 내용을 읽고, 귀하의 추가정보를 귀하의 컴퓨터에서 찾아 접속에 따른 아이디 등의 추가
            입력없이 서비스를 제공할 수 있습니다. 쿠키는 귀하의 컴퓨터는 식별하지만 귀하를 개인적으로 식별하지는 않습니다. 또한 귀하는 쿠키에 대한 선택권이 있습니다. 웹브라우저의 옵션을 조정함으로써 모든
            쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나 아니면 모든 쿠키를 거부할 수 있는 선택권을 가질 수 있습니다.</p>

        <h3>개인정보의 제3자에 대한 제공</h3>
        <p>HypeHaus는 귀하의 개인정보를 개인정보의 수집목적 및 이용목적에서 고지한 범위 내에서 사용하며, 동 범위를 초과하여 이용하거나 타인 또는 타기업/기관에 제공하지 않습니다. 그러나 보다 나은
            서비스 제공을 위하여 귀하의 개인정보를 제휴사에게 제공하거나 또는 제휴사와 공유할 수 있습니다. 단, 개인정보를 제공하거나 공유할 경우에는 사전에 귀하께 고지하여 드립니다.</p>

        <h3>개인정보의 열람/정정</h3>
        <p>귀하는 언제든지 등록되어 있는 귀하의 개인정보를 열람하거나 정정하실 수 있습니다. 개인정보 열람 및 정정을 하고자 할 경우에는 회원정보수정을 클릭하여 직접 열람 또는 정정하거나
            개인정보관리책임자에게 E-mail로 연락하시면 조치하여 드립니다. 귀하가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 당해 개인정보를 이용하지 않습니다.</p>

        <h3>개인정보 수집, 이용, 제공에 대한 동의철회</h3>
        <p>회원가입 등을 통해 개인정보의 수집, 이용, 제공에 대해 귀하께서 동의하신 내용을 귀하는 언제든지 철회할 수 있습니다. 동의철회는 웹사이트 및 개인정보관리책임자에게 E-mail 등으로 연락하시면
            즉시 개인정보의 삭제 등 필요한 조치를 하겠습니다.</p>

        <h3>개인정보의 보유기간 및 이용기간</h3>
        <p>귀하의 개인정보는 다음과 같이 개인정보의 수집목적 또는 제공받은 목적이 달성되면 파기됩니다.</p>
        <p style={styles.listItem}>- 회원 가입정보의 경우, 회원 가입을 탈퇴하거나 회원에서 제명된 때</p>
        <p style={styles.listItem}>- 예약의 경우, 예약에 따른 처리 및 진료가 완료된 때</p>
        <p>위 보유기간에도 불구하고 계속 보유하여야 할 필요가 있을 경우에는 귀하의 동의를 받습니다.</p>

        <h3>개인정보보호를 위한 기술적 대책</h3>
        <p>HypeHaus는 귀하의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.</p>
        <p>귀하의 개인정보는 비밀번호에 의해 보호되며, 파일 및 전송 데이터를 암호화하거나 파일 잠금기능(Lock)을 사용하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.</p>
        <p>HypeHaus는 회원인증과 관련 암호알고리즘을 이용하여 네트워크 상의 개인정보를 안전하게 전송할 수 있는 인증 및 보안장치를 채택하고 있으며, 시스템상 사정에 의해 미시행시 도우미에 의한 의사
            확인을 시행하고 있습니다.</p>
        <p>해킹 등에 의해 귀하의 개인정보가 유출되는 것을 방지하기 위해 외부로부터의 침입을 차단하는 장치를 이용하고 있으며, 각 서버마다 침입탐지시스템을 설치하여 24시간 침입을 감시하고 있습니다.</p>

        <h3>의견수렴 및 불만처리</h3>
        <p>HypeHaus는 개인정보보호와 관련하여 귀하가 의견과 불만을 제기할 수 있는 창구를 개설하고 있습니다. 개인정보와 관련한 불만이 있으신 분은 HypeHaus의 개인정보 관리책임자에게 의견을
            주시면 접수 즉시 조치하여 처리결과를 통보해 드립니다.</p>

        <h3>14세 미만 어린이들에 대한 보호정책</h3>
        <p>HypeHaus는 14세 미만 어린이들에 대한 회원 미가입 정책과 함께 개인정보를 부모의 동의 없이 제 3자와 공유하지 않으며 사용자에 관한 정보를 매매하거나 대여하지 않습니다.</p>

        <h3>개인정보 관리책임자</h3>
        <p>HypeHaus는 개인정보에 대한 의견수렴 및 불만처리의 정책을 담당하는 개인정보정책 담당 관리책임자를 지정하고 있습니다. 본 정책에 대한 불만사항이 있으시다면 아래 연락처로 문의 하시면 친절히
            처리하여 드리겠습니다.</p>

        <p style={styles.listItem}>개인정보정책 책임자</p>
        <p style={styles.listItem}>성 명 : 심혜미</p>
        <p style={styles.listItem}>소 속 : HypeHaus</p>
        <p style={styles.listItem}>이메일 : HypeHaus@naver.com</p>

        <h4>시행일</h4>
        <p>본 개인정보보호정책은 2022년 2월 8일부터 시행합니다.</p>
    </div>
);

// ----------------------------------------------------------------------
// 메인 페이지 컴포넌트
// ----------------------------------------------------------------------
const PolicyAppPage = () => {
    // 훅 호출 (컴포넌트 내부 최상단)
    // usePreventZoom();
    usePreventInputScroll();
    usePreventHorizontalScroll();

    const location = useLocation();
    const navigate = useNavigate();

    // URL 쿼리 파라미터 확인
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get('type') || 'privacy';

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [type]);

    const title = type === 'terms' ? '서비스 이용약관' : '개인정보처리방침';
    const content = type === 'terms' ? policyContent : privacyContent;

    // 현재 경로(location.pathname)를 유지하면서 쿼리 파라미터만 변경
    const handleTabClick = (newType) => {
        // 기존: navigate(`/policy/app?type=${newType}`); (경로 불일치 시 흰 화면)
        // 수정: 현재 경로를 그대로 사용
        navigate(`${location.pathname}?type=${newType}`, { replace: true });
    };

    // 탭 버튼 스타일 동적 생성
    const getTabStyle = (tabType) => ({
        ...styles.tabButton,
        borderBottom: type === tabType ? '2px solid #8052FF' : '2px solid transparent',
        color: type === tabType ? '#FFFFFF' : '#747474',
    });

    return (
        <div style={styles.backgroundWrapper}>
            <div style={styles.fixedHeaderWrapper}>
                <div className="statusBar" style={styles.statusBar} />
                <TopNavigator
                    title="약관 및 정책"
                    onBack={() => navigate('/setting', { replace: true })}
                />
            </div>

            <main style={styles.mainContent}>
                <div style={styles.tabContainer}>
                    <button
                        onClick={() => handleTabClick('terms')}
                        style={getTabStyle('terms')}
                    >
                        이용약관
                    </button>
                    <button
                        onClick={() => handleTabClick('privacy')}
                        style={getTabStyle('privacy')}
                    >
                        개인정보처리방침
                    </button>
                </div>

                <h2 style={styles.pageTitle}>{title}</h2>

                <div style={styles.contentWrapper}>
                    {content}
                </div>
            </main>
        </div>
    );
};

export default PolicyAppPage;